import { render, staticRenderFns } from "./QuestionnaireSurvey.vue?vue&type=template&id=3a4567d1&scoped=true"
import script from "./QuestionnaireSurvey.vue?vue&type=script&lang=js"
export * from "./QuestionnaireSurvey.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireSurvey.vue?vue&type=style&index=0&id=3a4567d1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4567d1",
  null
  
)

export default component.exports